import { oktaPost } from '../oktaRequestWrapper';
import { ApiRoutes } from '../apiRoutes';

export const updateDebtorFeedback = async (invoices: any) => {
  const requestConfig = {
    headers: {
      'api-version': '2.0',
    },
  };

  const response = await oktaPost(ApiRoutes.UpdateFeedback, invoices, requestConfig);
  return response.data;
};